<template>
  <!-- Header  -->
  <nav class="navbar navbar-expand-lg navbar-light bg-header">
    <div class="container-fluid">
      <div class="icone-seta-voltar" v-if="showSetaVoltar">
        <SetaVoltar />
      </div>
      <div class="logo">
        <router-link
          :to="{ name: 'Cardapios-Home', params: { nomeUrl: this.$route.params.nomeUrl }}"
        >{{ titulo }}</router-link>
        <div
          style="width: 24px; height: 24px; position: relative; float: right; border: 1px solid white; border-radius: 50%;"
        >
          <img
            @click="updateLocale(getCurrentLocaleData)"
            style="width: 20px; height: 20px; margin-top: 1px; display: block; margin-left: auto; margin-right: auto;"
            :src="i18n_locale_img"
          />
        </div>
      </div>
    </div>
  </nav>
  <!-- .Header  -->
</template>

<script>
import SetaVoltar from '@/views/cardapios/components/SetaVoltar';

export default {
  name: "Header",
  components: {
    SetaVoltar,
  },
  props: {
    titulo: String
  },

  computed: {
    showSetaVoltar() {
      return this.$route.name === 'Cardapios-Home' ? false : true
    },
    i18n_locale_img() {
      const locale = this.$i18n.locale
      if (locale === 'enUS') return require('@/assets/img/flags/brazil-flag.png')
      else if (locale === 'ptBR') return require('@/assets/img/flags/united-kingdom-flag.png')
      else return require('@/assets/img/flags/united-kingdom-flag.png')
    },
    getCurrentLocaleData() {
      const locale = this.$i18n.locale
      if (locale === 'enUS') return 'ptBR'
      else return 'enUS'
    }
  },

  methods: {
    updateLocale(locale) {
      this.$i18n.locale = locale
    }
  }
};
</script>

<style scoped>
.icone-seta-voltar {
  position: absolute;
  z-index: 0;
  margin: 0 auto;
}

.icone-seta-voltar,
.icone-seta-voltar a,
.icone-seta-voltar a:hover {
  color: #ffffff !important;
}

@media (min-width: 1024px) {
  .icone-seta-voltar {
    width: 800px;
    left: 50%;
    transform: translateX(-400px);
  }
}
</style>